import "../App.css";
import logo from "../imgs/Header.png";
import placeholder from "../imgs/placeholder.jpeg";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function getImage() {
    const queryParameters = new URLSearchParams(window.location.search);
    var id = queryParameters.get("id");
    return `/productInfo/${id}.png`;
}

function getID(){
    const queryParameters = new URLSearchParams(window.location.search);
    var id = queryParameters.get("id");
    return id;
}

const Product = () => {
    const navigate = useNavigate();
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        const imgPath = getImage();
        fetch(imgPath, { method: "HEAD" }) // Check if file exists
            .then(response => {
                const contentType = response.headers.get("Content-Type");
                if (response.ok && contentType && contentType.startsWith("image")) {
                    setImageSrc(imgPath); // Image exists, set source
                } else {
                    window.location.replace("/unavailable"); // Redirect if not a valid image
                }
            })
            .catch(() => window.location.replace("/unavailable")); // Handle network errors

    }, [navigate]);

    if (!imageSrc) return null; // Prevent rendering until check is complete

    return (
        <div className="App">
            <Helmet>
        <title>Heartland Fun: Product Info</title>
        <meta name="title" content="Heartland Fun: Product Info" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: Rental" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content={"https://heartland.csfrederick.com/" + getID()} />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
            <Navbar />
            <Warning />
            <p className="Blue InfoText Titillium Center FadeIn">
                <img src={imageSrc} alt="Product" className="imageMax"/>
                <br /><br />
                We pride ourselves on offering competitive prices and the latest technology in the industry. And if you're in Lawrence, KS, we invite you to come check us out in person. Don't miss out on the fun - contact Heartland Fun today!
            </p>
            <a href="tel:7858137921" className="Button Titillium Center">
                Connect with Our Experts
            </a>
            <Footer />
        </div>
    );
};

export default Product;
